import { Input, Modal, message } from "antd";
import React, { useEffect, useState } from "react";
import { MakeApiCall } from "../../../../apis";
import { LoadingModal } from "../../../../components/upload-modals";

const AddData = ({ visible, onClose, modalType, callAPI, selectedRow }) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (Object?.keys(selectedRow)?.length !== 0) {
      setInputValue(selectedRow?.group_name);
    }
  }, [selectedRow]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const UpdateAction = async (data) => {
    try {
      LoadingModal("Settings", "Updating...");
      const response = await MakeApiCall(
        `parameter-group/${selectedRow?.id}`,
        "put",
        {
          group_name: inputValue,
        },
        true
      );

      if (response?.status) {
        Modal.destroyAll();
        message.destroy();
        message.success(response?.message);
        setTimeout(() => {
          callAPI();
          onClose();
        }, 1500);
      } else {
        Modal.destroyAll();
        message.destroy();
        message.warning(response?.message);
      }
    } catch (error) {
      Modal.destroyAll();
    }
  };
  const AddUpdate = async (data) => {
    try {
      LoadingModal("Settings", "Adding...");
      const response = await MakeApiCall(
        `parameter-group`,
        "post",
        {
          group_name: inputValue,
        },
        true
      );

      if (response?.status) {
        Modal.destroyAll();
        message.destroy();
        message.success(response?.message);
        setTimeout(() => {
          callAPI();
          onClose();
        }, 1500);
      } else {
        Modal.destroyAll();
        message.destroy();
        message.warning(response?.message);
      }
    } catch (error) {
      Modal.destroyAll();
    }
  };

  const handleOk = () => {
    if (!inputValue) {
      message.destroy();
      return message.warning("Please Enter Group Name");
    }
    message.destroy();

    if (modalType === "Add") {
      AddUpdate(inputValue);
    } else {
      UpdateAction(inputValue);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      title={`${modalType} Parameter Groups`}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div className="mb-5">
        <label className="mt-3 mb-1">
          <span>Parameter Group Name</span>
        </label>
        <Input
          placeholder="Enter Parameter Groups"
          value={inputValue}
          onChange={handleInputChange}
        />
      </div>
    </Modal>
  );
};

export default AddData;
